import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";

const STATUS_FLOW = {
  PENDING: ["CONFIRMED", "CANCELLED"],
  CONFIRMED: ["PROCESSING", "CANCELLED"],
  PROCESSING: ["DISPATCHED"],
  DISPATCHED: ["DELIVERED"],
  DELIVERED: [],
  CANCELLED: [],
};
const STATUSES = ["PENDING", "CONFIRMED", "PROCESSING", "DISPATCHED", "DELIVERED", "CANCELLED"];

export default function Orders() {
  const [tab, setTab] = useState("ALL");
  const [items, setItems] = useState([]);
  const load = async () => {
    const params = tab === "ALL" ? {} : { status: tab };
    const { data } = await api.get("/sales/orders", { params });
    setItems(data);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [tab]);

  const advance = async (o, status) => {
    try { await api.post(`/sales/orders/${o.id}/transition`, null, { params: { status } }); toast.success(`→ ${status}`); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6" data-testid="sales-orders">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-black">Sales orders</h1>
        <p className="text-muted-foreground">Track every order from PENDING → DELIVERED. Warehouse & delivery assignment from the order detail.</p>
      </div>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="ALL" data-testid="order-tab-ALL">All</TabsTrigger>
          {STATUSES.map((s) => <TabsTrigger key={s} value={s} data-testid={`order-tab-${s}`}>{s}</TabsTrigger>)}
        </TabsList>
      </Tabs>
      <div className="surface-card p-4 overflow-x-auto">
        <Table>
          <TableHeader><TableRow><TableHead>Number</TableHead><TableHead>Customer</TableHead><TableHead>Total</TableHead><TableHead>Status</TableHead><TableHead>Created</TableHead><TableHead className="text-right">Advance</TableHead></TableRow></TableHeader>
          <TableBody>
            {items.map((o) => (
              <TableRow key={o.id} data-testid={`order-row-${o.id}`}>
                <TableCell className="font-mono text-xs font-semibold">{o.number}</TableCell>
                <TableCell>{o.customer_name}</TableCell>
                <TableCell>₹{(o.total || 0).toLocaleString()}</TableCell>
                <TableCell><Badge>{o.status}</Badge></TableCell>
                <TableCell className="font-mono text-[10px]">{new Date(o.created_at).toLocaleDateString()}</TableCell>
                <TableCell className="text-right space-x-1">
                  {(STATUS_FLOW[o.status] || []).map((s) => (
                    <Button key={s} size="sm" variant={s === "CANCELLED" ? "outline" : "default"} onClick={() => advance(o, s)} data-testid={`order-${o.id}-to-${s}`}>{s}</Button>
                  ))}
                </TableCell>
              </TableRow>
            ))}
            {items.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-muted-foreground py-10">No orders yet.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
